import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';

import WidgetOfficeHeader from '../../components/WidgetOfficeHeader';
import OfficeSchedulingPage from './OfficeSchedulingPage';

export const OFFICE_SCHEDULING_PAGE_QUERY = gql`
  query OfficeSchedulingPage($id: ID!) {
    office(id: $id) {
      id
      phone
      viewOpeningsBy
      timeZoneCode
      practice {
        id
        display
      }
      reasonsForVisit(perPage: 100) {
        nodes {
          id
          name
          patientStatus
          visibleOnWidget
        }
      }
      reviewsEnabled
      onlineSchedulingEnabled
      patientScreenerEnabled
      localmedRating: currentRating(serviceType: LOCALMED) {
        ...OfficeSchedulingPageRating
      }
      facebookRating: currentRating(serviceType: FACEBOOK) {
        ...OfficeSchedulingPageRating
      }
      googleRating: currentRating(serviceType: GOOGLE) {
        ...OfficeSchedulingPageRating
      }
      yelpRating: currentRating(serviceType: YELP) {
        ...OfficeSchedulingPageRating
      }
      ...${WidgetOfficeHeader.fragment.name}
      announcementEnabled
      announcement {
        type
        content
        moreUrl
      }
    }
  }
  fragment OfficeSchedulingPageRating on Rating {
    rating
    reviewCount
    serviceType
  }
  ${WidgetOfficeHeader.fragment.query}
`;

const OfficeSchedulingPageWithData = graphql(OFFICE_SCHEDULING_PAGE_QUERY, {
  options({ match: { params } }) {
    return { variables: params };
  },
})(OfficeSchedulingPage);

OfficeSchedulingPageWithData.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }),
};

export default OfficeSchedulingPageWithData;
